import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Paper
} from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    buttons: {
        textAlign: 'right'
    }
});



const BinaryImageTypeForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;

    return (
        <Paper className={classes.root}>
            <BackButton />
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit, isSubmitting } = formikProps;

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>

                            <TextField
                                name="Key"
                                value={values.Key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Key && touched.Key)}
                                placeholder={translations["key"] || "Key"}
                                label={translations["key"] || "Key"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />

                            <div className={classes.buttons}>
                                {formSettings.ButtonCancel ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                        disabled={loading}

                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(BinaryImageTypeForm);
